export default "__VITE_ASSET__B5NQC4aw__"